/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/component/aboutScrollBg.js":
/*!*******************************************!*\
  !*** ./src/js/component/aboutScrollBg.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ aboutScrollBg)
/* harmony export */ });
class aboutScrollBg {
  constructor() {
    const abouScentSection = document.querySelector('.p-about-scent');
    let abouScentSectionPos;

    if(abouScentSection != null){
      const abouScentSectionBg = document.querySelector('.p-about-scent-bg');
      headerScrollOn();

      window.addEventListener('scroll',()=>{
        headerScrollOn();
      }, false);

      function headerScrollOn() {
        abouScentSectionPos = abouScentSection.getBoundingClientRect();
        if(abouScentSectionPos.top - (window.innerHeight * 0.3) < 0){
          abouScentSectionBg.classList.add('is-active');
        } else {
          abouScentSectionBg.classList.remove('is-active');
        }
      }
    }
  }
}

/***/ }),

/***/ "./src/js/component/headerScroll.js":
/*!******************************************!*\
  !*** ./src/js/component/headerScroll.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ headerScroll)
/* harmony export */ });
class headerScroll {
  constructor() {
    const header = document.querySelector('.header--transparent');

    if(header != null){
      headerScrollOn();

      window.addEventListener('scroll',()=>{
        headerScrollOn();
      }, false);

      function headerScrollOn() {
        if(window.scrollY > 150){
          header.classList.remove('is-scrollOff');
        } else {
          header.classList.add('is-scrollOff');
        }
      }
    }

  }
}

/***/ }),

/***/ "./src/js/component/lazyFooterMovie.js":
/*!*********************************************!*\
  !*** ./src/js/component/lazyFooterMovie.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ lazyFooterMovie)
/* harmony export */ });
class lazyFooterMovie {
  constructor() {
    const target = document.querySelector('.footer__newsletter__bg video');

    if(target != null){

      //オプション
      const options = {
        rootMargin: "0px 0px",
        threshold: 0,
      };

      //実行
      const observer = new IntersectionObserver(lazyLoad, options);
      observer.observe(target);

      // 背景の表示
      function lazyLoad(entries){
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let videoSource = target.children[0];
            videoSource.src = videoSource.dataset.src;
            target.load();
            observer.unobserve(target);
          }
        });
      };

    }

  }
}

/***/ }),

/***/ "./src/js/component/observer.js":
/*!**************************************!*\
  !*** ./src/js/component/observer.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ observer)
/* harmony export */ });
class observer {
  constructor() {

    //要素を指定
    const targets = document.querySelectorAll('.js-observer');

    //オプション
    const options = {
      rootMargin: "-30% 0px",
      threshold: 0,
    };

    //実行
    const observer = new IntersectionObserver(showElements, options);

    //複数要素に適用
    targets.forEach(target => {
      observer.observe(target);
    });

    // 要素が表示されたら実行する動作
    function showElements(entries){
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 各 .heading に .active を加える
          entry.target.classList.add('active');
        }
      });
    };
  }
}

/***/ }),

/***/ "./src/js/component/smudge.js":
/*!************************************!*\
  !*** ./src/js/component/smudge.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ smudge)
/* harmony export */ });
class smudge {
  constructor() {
    if(document.querySelector('.p-cf-product-ingredients') != null){
      const targets = document.querySelectorAll('.p-clip-hexagon');
      const targetsBg = document.querySelectorAll('.p-clip-hexagon__smudge');

      for(let i = 0; i < targets.length; i++){
        targets[i].addEventListener('mouseover', (e) => {
          if(!targets[i].classList.contains('active')){
            targets[i].classList.add('active');
            targetsBg[i].style.top = e.layerY + 'px';
            targetsBg[i].style.left = e.layerX + 'px';
          }
        });
        targets[i].addEventListener('mouseleave', (e) => {
          targets[i].classList.remove('active');
        });
      }

    }
  }
}

/***/ }),

/***/ "./src/js/component/swiperAboutType.js":
/*!*********************************************!*\
  !*** ./src/js/component/swiperAboutType.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ swiperAboutType)
/* harmony export */ });
class swiperAboutType {
  constructor() {

    if(document.querySelector('.js-swiperAboutType') != null){

      let swiperAboutType, swiperbool;
      const breakPoint = 768;

      if (window.innerWidth < breakPoint) {
        createSwiper();
        swiperbool = true;
        // console.log('create');
      } else {
        swiperbool = false;
        // console.log('destroy');
      }

      window.addEventListener('resize',()=>{
        if( window.innerWidth < breakPoint && !(swiperbool)){
          createSwiper();
          swiperbool = true;
          // console.log('create');
        }else if( window.innerWidth >= breakPoint && swiperbool){
          swiperAboutType.destroy(false,true);
          swiperbool = false;
          // console.log('destroy');
        }
      }, false);

      function createSwiper() {
        swiperAboutType = new Swiper(".js-swiperAboutType", {
          loop: true,
          speed: 2000,
          allowTouchMove: false,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
          },
          effect: 'fade',
        });
      }
    }
  }
}

/***/ }),

/***/ "./src/js/component/swiperCfIngredients.js":
/*!*************************************************!*\
  !*** ./src/js/component/swiperCfIngredients.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ swiperCfIngredients)
/* harmony export */ });
class swiperCfIngredients {
  constructor() {

    if(document.querySelector('.js-swiperCfIngredients') != null){

      let swiperCfIngredients, swiperbool;
      const breakPoint = 768;

      if (window.innerWidth < breakPoint) {
        createSwiper();
        swiperbool = true;
        // console.log('create');
      } else {
        swiperbool = false;
        // console.log('destroy');
      }

      window.addEventListener('resize',()=>{
        if( window.innerWidth < breakPoint && !(swiperbool)){
          createSwiper();
          swiperbool = true;
          // console.log('create');
        }else if( window.innerWidth >= breakPoint && swiperbool){
          swiperCfIngredients.destroy(false,true);
          swiperbool = false;
          // console.log('destroy');
        }
      }, false);

      function createSwiper() {
        swiperCfIngredients = new Swiper(".js-swiperCfIngredients", {
          // loop: true,
          speed: 800,
          slidesPerView: 1,
          autoHeight: true,
          spaceBetween: 80,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
      }
    }
  }
}

/***/ }),

/***/ "./src/js/component/swiperMainProduct.js":
/*!***********************************************!*\
  !*** ./src/js/component/swiperMainProduct.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ swiperMainProduct)
/* harmony export */ });
class swiperMainProduct {
  constructor() {

    if(document.querySelector('.js-swiperMainProduct') != null){

      let swiperMainProduct, swiperbool;
      const breakPoint = 768;

      if (window.innerWidth < breakPoint) {
        createSwiper();
        swiperbool = true;
        // console.log('create');
      } else {
        swiperbool = false;
        // console.log('destroy');
      }

      window.addEventListener('resize',()=>{
        if( window.innerWidth < breakPoint && !(swiperbool)){
          createSwiper();
          swiperbool = true;
          // console.log('create');
        }else if( window.innerWidth >= breakPoint && swiperbool){
          swiperMainProduct.destroy(false,true);
          swiperbool = false;
          // console.log('destroy');
        }
      }, false);

      function createSwiper() {
        swiperMainProduct = new Swiper(".js-swiperMainProduct", {
          loop: true,
          speed: 800,
          slidesPerView: 1,
          autoHeight: true,
          spaceBetween: 50,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
      }
    }
  }
}

/***/ }),

/***/ "./src/js/component/swiperMv.js":
/*!**************************************!*\
  !*** ./src/js/component/swiperMv.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ swiperMv)
/* harmony export */ });
class swiperMv {
  constructor() {

    if(document.querySelector('.js-swiperMv') != null){
      const swiperMvNumCurrent = document.querySelector('.js-swiperMv .swiper-pagenumber .js-mvCurrent');
      const swiperMvNumLength = document.querySelector('.js-swiperMv .swiper-pagenumber .js-mvLength');
      const swiperMvItems = document.querySelectorAll('.js-swiperMv .swiper-slide').length;
      swiperMvNumLength.innerText = '0' + swiperMvItems;

      const swiperMv = new Swiper(".js-swiperMv", {
        loop: true,
        speed: 2000,
        allowTouchMove: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        effect: 'fade',
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          slideChangeTransitionStart: function() {
            swiperMvNumCurrent.innerText = '0' + (swiperMv.realIndex + 1);
          },
        }
      });
    }

  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
var __webpack_exports__ = {};
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component_aboutScrollBg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component/aboutScrollBg */ "./src/js/component/aboutScrollBg.js");
/* harmony import */ var _component_headerScroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./component/headerScroll */ "./src/js/component/headerScroll.js");
/* harmony import */ var _component_lazyFooterMovie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./component/lazyFooterMovie */ "./src/js/component/lazyFooterMovie.js");
/* harmony import */ var _component_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./component/observer */ "./src/js/component/observer.js");
/* harmony import */ var _component_smudge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./component/smudge */ "./src/js/component/smudge.js");
/* harmony import */ var _component_swiperAboutType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./component/swiperAboutType */ "./src/js/component/swiperAboutType.js");
/* harmony import */ var _component_swiperMainProduct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./component/swiperMainProduct */ "./src/js/component/swiperMainProduct.js");
/* harmony import */ var _component_swiperCfIngredients__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./component/swiperCfIngredients */ "./src/js/component/swiperCfIngredients.js");
/* harmony import */ var _component_swiperMv__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./component/swiperMv */ "./src/js/component/swiperMv.js");












window.addEventListener('load', () => {
  new _component_aboutScrollBg__WEBPACK_IMPORTED_MODULE_0__["default"]();
  new _component_headerScroll__WEBPACK_IMPORTED_MODULE_1__["default"]();
  new _component_lazyFooterMovie__WEBPACK_IMPORTED_MODULE_2__["default"]();
  new _component_observer__WEBPACK_IMPORTED_MODULE_3__["default"]();
  // new smudge();
  new _component_swiperAboutType__WEBPACK_IMPORTED_MODULE_5__["default"]();
  new _component_swiperCfIngredients__WEBPACK_IMPORTED_MODULE_7__["default"]();
  new _component_swiperMainProduct__WEBPACK_IMPORTED_MODULE_6__["default"]();
  new _component_swiperMv__WEBPACK_IMPORTED_MODULE_8__["default"]();
});
})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;